export const STORE_USER_CONFIGURATION = 'STORE_USER_CONFIGURATION';
export const storeUserConfiguration = (userConfiguration) => ({
    type: STORE_USER_CONFIGURATION,
    payload: userConfiguration,
});

export const UPDATE_BIDDING_USER_CONFIGURATION = 'UPDATE_BIDDING_USER_CONFIGURATION';
export const updateBiddingUserConfiguration = (defaultPrice, defaultQuantity, priceStep, quantityStep) => ({
    type: UPDATE_BIDDING_USER_CONFIGURATION,
    payload: {
        defaultPrice,
        defaultQuantity,
        priceStep,
        quantityStep,
    },
});

export const UPDATE_TRUSTED_DEVICES_USER_CONFIGURATION = 'UPDATE_TRUSTED_DEVICES_USER_CONFIGURATION';
export const updateTrustedDeviceUserConfiguration = (hasTrustedDevice) => ({
    type: UPDATE_TRUSTED_DEVICES_USER_CONFIGURATION,
    payload: hasTrustedDevice,
});
